import { render, staticRenderFns } from "./ResizePanelArrows.vue?vue&type=template&id=73ad3abd&"
import script from "./ResizePanelArrows.vue?vue&type=script&lang=js&"
export * from "./ResizePanelArrows.vue?vue&type=script&lang=js&"
import style0 from "./ResizePanelArrows.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports